import React, { useState, useEffect } from 'react';
import { Grid } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import { useSnackbar } from 'notistack';
import MUIDataTable from 'mui-datatables';
import moment from 'moment';
import JWTDecoder from 'jwt-decode';

import Api from '../../Api';
import EquipmentCertificateModal from './components/EquipmentCertificateModal';
import NewEquipmentCertificateModal from './components/NewEquipmentCertificateModal';
import GenericToolbar from '../../components/GenericToolbar/GenericToolbar';

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(3)
  },
  content: {
    marginTop: theme.spacing(2)
  }
}));

const EquipmentsCertificates = () => {
  const classes = useStyles();
  const { enqueueSnackbar } = useSnackbar();
  const jwt = localStorage.getItem('access-jwt');
  var jwtUser = [];
  if (jwt !== null) {
    jwtUser = JWTDecoder(localStorage.getItem('access-jwt'));
  }

  const columns = [
    {
      name: 'id',
      label: 'ID',
      options: {
        filter: false,
        sort: true,
        sortDirection: 'desc',
        display: false
      }
    },
    {
      name: 'equipment_name',
      label: 'Equipo',
      options: {
        filter: true,
        sort: true
      }
    },
    {
      name: 'certificate_year',
      label: 'Año',
      options: {
        filter: true,
        sort: true
      }
    }
  ];
  const options = {
    filter: false,
    responsive: 'standard',
    enableNestedDataAccess: '.',
    selectableRows: 'none',
    viewColumns: false,
    download: false,
    print: false,
    onRowClick: row => {
      handleClickOpen(row);
    },
    textLabels: {
      body: {
        noMatch: 'No hay resultados por ahora',
        toolTip: 'Order',
        columnHeaderTooltip: column => `Ordernar por ${column.label}`
      },
      pagination: {
        next: 'Pagina siguiente',
        previous: 'Pagina anterior',
        rowsPerPage: 'Filas por página:',
        displayRows: 'de'
      },
      toolbar: {
        search: 'Buscar',
        downloadCsv: 'Descargar CSV',
        print: 'Imprimir',
        viewColumns: 'Columnas',
        filterTable: 'Filtros'
      },
      filter: {
        all: 'Todos',
        title: 'FILTROS',
        reset: 'BORRAR FILTROS'
      },
      viewColumns: {
        title: 'Mostrar Columnas',
        titleAria: 'Mostrar/Ocultar Columnas'
      },
      selectedRows: {
        text: 'fila(s) seleccionada',
        delete: 'Eliminar',
        deleteAria: 'Eliminar filas seleccionadas'
      }
    }
  };

  const [visibility, setVisibility] = useState(false);
  const [visibilityNew, setVisibilityNew] = useState(false);
  const [selectedEquipmentCertificate, setSelectedEquipmentCertificate] = useState({});
  const [selectedEquipmentCertificateFiles, setSelectedEquipmentCertificateFiles] = useState({});

  const handleClickOpen = row => {
    equipmentsCertificates.forEach(equipmentCertificate => {
      if (equipmentCertificate.id === row[0]) {
        setSelectedEquipmentCertificate(equipmentCertificate);
        setSelectedEquipmentCertificateFiles(equipmentCertificate.files);
      }
    });
    setVisibility(true);
  };

  const handleClickOpenNew = () => {
    setVisibilityNew(true);
  };

  const handleCloseNew = success => {
    if (success) {
      loadEquipmentsCertificates();
    }
    setVisibilityNew(false);
  };

  const handleClose = success => {
    if (success) {
      loadEquipmentsCertificates();
    }
    setVisibility(false);
  };

  const [equipmentsCertificates, setEquipmentsCertificates] = useState([]);

  const loadEquipmentsCertificates = () => {
    Api.get('/equipments_certificates')
      .then(function(response) {
        response.data.data.forEach(r => {
          r.created_on_formatted = moment(r.created_on).format('DD/MM/YYYY');
        });
        setEquipmentsCertificates(response.data.data);
      })
      .catch(function(error) {
        var message = 'Error de conexion, contacta a soporte';
        if (error.response) {
          setEquipmentsCertificates([]);
        } else {
          enqueueSnackbar(message, {
            anchorOrigin: {
              vertical: 'top',
              horizontal: 'center'
            },
            variant: 'error'
          });
        }
      });
  };

  useEffect(() => {
    loadEquipmentsCertificates();
  }, []);

  return (
    <div className={classes.root}>
      {jwtUser.u_role_id !== 3 ? <GenericToolbar handleClickOpenNew={handleClickOpenNew} /> : null}
      <div className={classes.content}>
        <Grid container spacing={3} justify="center" alignItems="center">
          <Grid item xs={6}>
            <MUIDataTable title={'Lista de Certificados de Equipos'} data={equipmentsCertificates} columns={columns} options={options} />
          </Grid>
        </Grid>
      </div>
      <EquipmentCertificateModal
        handleClose={handleClose}
        logedUser={jwtUser}
        visibility={visibility}
        equipmentCertificate={selectedEquipmentCertificate}
        equipmentCertificateFiles={selectedEquipmentCertificateFiles}
      />
      <NewEquipmentCertificateModal handleClose={handleCloseNew} visibility={visibilityNew} />
    </div>
  );
};

export default EquipmentsCertificates;
